import data from "@/data/portalContent.json";
import uiData from "@/data/portalUi.json";

const LANGS = ["en", "nl", "bg", "uk"];

export function getUi(lang) {
  const ui = uiData[lang] || uiData.en;
  return (key) => (ui[key] ?? uiData.en[key] ?? key);
}

export function getTiles(lang) {
  return data.tiles[lang] || data.tiles.en;
}

export function getSessionContent(lang, number) {
  const byLang = data.content[lang] || {};
  const sections = byLang[String(number)] || data.content.en[String(number)] || [];
  return sections;
}

export function getTile(lang, number) {
  return getTiles(lang).find((t) => t.number === number) || getTiles("en").find((t) => t.number === number);
}

// Map a "<x>-gallery" section kind to the portal metadata image-id key.
export function galleryKeyFor(kind) {
  if (kind === "infographic-gallery") return "image_ids";
  const base = kind.replace(/-gallery$/, "").replace(/-/g, "_");
  return `${base}_image_ids`;
}

export { LANGS };
